export default "__VITE_ASSET__DkD_yaRu__"